import {useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {Page} from '../../common/constant/page';
import useLogin from '../../common/hook/useLogin';
import useTypedSelector from '../../common/hook/useTypedSelector';
import {IAdultMap} from '../../common/type';
import {getUrl} from '../../common/util/PageRouter';
import {
  getIsRouteToParams,
  subscribeRouteCancel,
} from '../../common/util/PageRouter/routeCancelObserver';
import {getIsNotAllowedAdultContent} from '../function';

export default function useRouteToContentObserver() {
  const dispatch = useDispatch();
  const {isLogin, isLoginChecking} = useLogin();
  const [user] = useTypedSelector(state => [state.auth.user]);
  useEffect(() => {
    return subscribeRouteCancel((_, params) => {
      if (getIsRouteToParams(params) && params.page === Page.Content) {
        let contentId = 0;
        let sid = '';
        if (typeof params.info === 'string') {
          const path = params.info.split('?')[0]?.split('/');
          let firstIdx = 0;
          path[0] === '' && (firstIdx = 1);
          sid = path[firstIdx + 1];
          contentId = Number(path[firstIdx + 2]);
        } else if (params.info.page === Page.Content) {
          contentId = params.info.id;
          sid = params.info.sid;
        }

        const isAdult = contentAdultMap[contentId];
        if (isAdult) {
          return getIsNotAllowedAdultContent({
            isLoginChecking,
            isLogin,
            user,
            pastUrl: getUrl({page: Page.Content, id: contentId, sid}),
          });
        } else {
          return false;
        }
      } else {
        return false;
      }
    });
  }, [isLogin, dispatch, user, isLoginChecking]);
}

export let contentAdultMap: IAdultMap = {};
export function initializeContentAdultMap() {
  contentAdultMap = {};
}
